import { render, staticRenderFns } from "./AsterikaBody.vue?vue&type=template&id=19d141c5&scoped=true"
import script from "./AsterikaBody.vue?vue&type=script&lang=js"
export * from "./AsterikaBody.vue?vue&type=script&lang=js"
import style0 from "./AsterikaBody.vue?vue&type=style&index=0&id=19d141c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d141c5",
  null
  
)

export default component.exports